import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import App from "./App";
import "./index.css";

Amplify.configure(awsconfig);

if (window.location.search.includes("error=")) {
  console.error("Cognito OAuth error:",
    new URLSearchParams(window.location.search).toString());
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
